/**
 * OneClick V2 Anti-DDoS 配置全局初始化 Hook
 *
 * 在 _app.tsx GlobalHooks 中调用，确保应用启动时就开始
 * 加载并定时刷新 Anti-DDoS 配置（60s 间隔）。
 * 与 useOneClickTradingV2 不同，此 hook 不依赖 trade 组件生命周期，
 * 在应用级别持续运行。
 */

import { useEffect } from 'react';
import {
  startAntiDdosConfigRefresh,
  stopAntiDdosConfigRefresh,
} from '@ui/services/backend/oneClickV2Service';

export const useAntiDdosConfigInit = () => {
  useEffect(() => {
    startAntiDdosConfigRefresh();

    return () => {
      stopAntiDdosConfigRefresh();
    };
  }, []);
};
